import { Component, Input, OnInit, ElementRef, ViewChild, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable,of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { Studies } from '../model/recruiter.model';

import { RecruiterServices } from '../../shared/services/recruiter.services';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';


export interface Fruit {
  name: string;
}


@Component({
  selector: 'app-assign-study',
  templateUrl: './assign-study.component.html',
  styleUrls: ['./assign-study.component.scss']
})
export class AssignStudyComponent implements OnInit, AfterViewInit {
  @Input() formatedStudy: any;
  @Output() selectedStudyEvent = new EventEmitter<any>();
  @Input() selectedStudy: any = [];
  @Input () componentType:string;


  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  filteredFruits: Observable<any[]>;
  fruits: any[] = [];
  allFruits: any;
  testing: any;
  placeholder: string;
  flag = true;

  @ViewChild('fruitInput', {static: false}) fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('studyId', {static: false}) studyId: any;
  @ViewChild('auto', {static: false}) matAutocomplete: MatAutocomplete;
  @ViewChild('local', {static: false}) local: ElementRef<HTMLInputElement>;
  @ViewChild('temp2', {static: false}) temp2: ElementRef<HTMLInputElement>;

  constructor(private el: ElementRef, private logerror: LoginService, private router: Router, private recruiterServices: RecruiterServices) {

  }

  ngOnInit(): void {
    this.testing = 'Praveen';
    this.allFruits = this.formatedStudy;
    if (this.placeholder === undefined) {
      this.placeholder = 'Select Study'
    }
    for (let i = 0; i < this.selectedStudy.length; i++) {
      this._removefilter(this.selectedStudy[i].id);
    }

    this.fruitCtrl.valueChanges.subscribe(keyword => { 
      if( keyword !=null &&  keyword.length >=2   ){

    this.recruiterServices.getAllRecruiterBykeyword(keyword,this.componentType).subscribe(data => {
            this.filteredFruits = of(data.result); 
    },
    error=>{
      if(error.status == 401){
        this.router.navigate(['home/access-denied']);
      }
    });
    }       

    });



    if (this.selectedStudy) {
      this.selectedStudy.filter(study => {
        this.fruits.push(study);
      })
    }
  }

  ngAfterViewInit(): void {
    this.selectedStudyEvent.emit(this.fruits);
  }

  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
    }
    else {
      if (this.flag) {
        let local = this.local;
        let temp2 = this.temp2;
        setTimeout(function () {
          local.nativeElement.value = 'abc';
          local.nativeElement.focus();
          setTimeout(function () {
            // temp2.nativeElement.focus();
          })
        }, 150);
      }
    }

  }

  remove(fruit: string): void {
    const index = this.fruits.indexOf(fruit);
    if (index >= 0) {
      this.fruits.splice(index, 1);

      // add removed study in drop down list
      this._addfilter(fruit);
      // reload observable data
   //   this._reloadData();
    }
    this.selectedStudyEvent.emit(this.fruits);
    this.flag = true;
  }


  selected(event: MatAutocompleteSelectedEvent): void {
    this.fruits.push({ name: event.option.viewValue, id: event.option.value });
    // remove added option in drop down list 
    this._removefilter(event.option.value);
    // reload observable data
  //  this._reloadData();
    this.fruitInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);
    this.selectedStudyEvent.emit(this.fruits);
    this.flag = true;
  }

  private _filter(value: any): any[] {
    this.flag = true;
    const fvalue = value.trim();
    this.recruiterServices.getAllRecruiterBykeyword(fvalue,this.componentType).subscribe(data => {
      this.flag = true;
      this.allFruits = data.result;
    },
    error=>{
      if(error.status == 401){
        this.router.navigate(['home/access-denied']);
      }
    });
    return this.allFruits;
  }

  // function to remove selected from dropdown
  private _removefilter(id) { 
    
    this.flag = true;
 //   this.allFruits = this.allFruits.filter(item => { return item.id != id });
  }

  // function to add removed in dropdown
  private _addfilter(obj) {
    this.flag = true;
    this.allFruits.push(obj);
  }

  // function to reload data in observable
  private _reloadData() {

    this.flag = true;
    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: any | null) => fruit ? this._filter(fruit) : this.allFruits.slice())
    );
  }
  he() {
  }
  mouselv() {
    this.flag = false;
  }
  mouseen() {
    this.flag = true;
  }
  mouselea() {
  }


}

